import gsap from "../../../../helpers/gsapInstance";
import MainPageCommonService from "../../../../services/main-page/MainPageCommonService";
import MainPageFirstScreenCommon from "./MainPageFirstScreenCommon";

export default class MainPageFirstScreenMobile extends MainPageCommonService {
    private readonly $holder: JQuery;
    public readonly $labels: JQuery;

    constructor($holder: JQuery) {
        super();

        this.$holder = $holder;
        this.$labels = this.$holder.find(MainPageFirstScreenCommon.selectors.label);

        this.changeLabelsOnFirstScreen = this.changeLabelsOnFirstScreen.bind(this);
    }

    /**
     * Функция обработчик клика на labels на первом экране
     * @private
     * @param target
     */
    public changeLabelsOnFirstScreen(target: JQuery<HTMLElement>): void {
        this.$labels.each((_, item) => {
            const $item = $(item);

            if ($item.hasClass(this.ACTIVE_CLASS)) {
                $item.removeClass(this.ACTIVE_CLASS);
            }
        });

        target.addClass(this.ACTIVE_CLASS);
    }
}
